import { Routes } from '@angular/router';
import { AuthenticateGuard } from './core/guards/authenticate.guard';
import { IsDesktopGuard } from './core/guards/is-desktop.guard';

export const appRoutes: Routes = [
  {
    path: 'app',
    loadChildren: () =>
      import('./modules/logged-area/logged-area.routes').then((m) => m.loggedAreaRoutes),
    canActivate: [AuthenticateGuard],
    data: { breadcrumb: { skip: true } },
  },
  {
    path: 'ios',
    loadChildren: () => import('./modules/ios-area/ios-area.routes').then((m) => m.iosAreaRoutes),
    canActivate: [IsDesktopGuard],
  },
  {
    path: '',
    loadChildren: () =>
      import('./modules/public-area/public-area.routes').then((m) => m.publicAreaRoutes),
  },
];
